import { render, staticRenderFns } from "./MapCompassNavigation.vue?vue&type=template&id=8737abbc"
import script from "./MapCompassNavigation.vue?vue&type=script&lang=js"
export * from "./MapCompassNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports